/* 
* Copyright (c) 2026 Send2Me, media capture and delivery platform. All rights reserved. 
* Distributed under the TruVideo proprietary license. 
*/
import PropTypes from 'prop-types';
import { Send } from 'lucide-react';
import './capture.css';

const Submitting = ({
  submitProgress,
  branding,
  pageBgStyle,
  welcomeBgClass
}) => {
  const overallPct = submitProgress.total === 0 ? 0 :
    Math.round(((submitProgress.itemIndex / submitProgress.total) * 100) + (submitProgress.current / submitProgress.total));

  return (
    <div data-theme={branding.theme || 'light'} className={`min-h-screen flex flex-col font-sans transition-colors duration-500 bg-base-100 text-base-content capture-container`}>
      <div className="flex-1 flex flex-col items-center justify-center p-8 text-center max-w-md mx-auto w-full">
        <div className="mb-10 relative">
          <div className="w-20 h-20 bg-base-100 shadow-xl rounded-[1.5rem] border border-base-300 flex items-center justify-center text-primary overflow-hidden">
            <Send size={32} strokeWidth={2.5} className="animate-bounce-slow" />
          </div>
          <div className="absolute -inset-4 bg-primary/10 blur-2xl rounded-full -z-10 animate-pulse" />
        </div>

        <h2 className="text-[28px] leading-tight font-black text-base-content mb-2 tracking-tight uppercase">Uploading Media</h2>
        <p className="text-base-content/40 font-bold text-xs uppercase tracking-widest mb-10 px-6">Securing and transmitting your evidence</p>

        <div className="w-full bg-base-100 shadow-xl rounded-[1.5rem] p-8 border border-base-300">
          <div className="flex justify-between items-center mb-4">
            <span className="text-[10px] font-black text-base-content/30 uppercase tracking-[0.2em]">Global Progress</span>
            <span className="text-[11px] font-black text-primary tracking-widest">{overallPct}%</span>
          </div>
          <div className="w-full bg-base-200 rounded-full h-1.5 overflow-hidden">
            <div
              className="h-full rounded-full transition-all duration-500 shadow-sm bg-primary"
              style={{ width: `${overallPct}%` }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Submitting;

Submitting.propTypes = {
  submitProgress: PropTypes.shape({
    total: PropTypes.number,
    itemIndex: PropTypes.number,
    current: PropTypes.number,
  }),
  branding: PropTypes.shape({
    theme: PropTypes.string,
  }),
  pageBgStyle: PropTypes.any,
  welcomeBgClass: PropTypes.string,
};